module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/171-galapagos-islands-a9f3cf5c75f23567bae04747a7c06165.svg";